import { IPreviewPhonenumberMonthlyCostParent, } from 'atlas-shared';
import { IPhonenumberMonthlyCostParentStore, PhonenumberMonthlyCostParentActions, TPhonenumberMonthlyCostParentActionTypes, } from '@Store';

export const PhonenumberMonthlyCostParentReducer = (state: IPhonenumberMonthlyCostParentStore = {
  loaded: false,
  loading: false,
  phonenumber_monthly_cost_parents: [],
  dict: {},
}, action: TPhonenumberMonthlyCostParentActionTypes): IPhonenumberMonthlyCostParentStore => {
  switch (action.type) {
  case PhonenumberMonthlyCostParentActions.LOADING:
    return { ...state, loading: true, };
  case PhonenumberMonthlyCostParentActions.SET_STATE:
    const dict: IPhonenumberMonthlyCostParentStore['dict'] = {};

    action.payload.forEach((phonenumber_monthly_cost_parent: IPreviewPhonenumberMonthlyCostParent) => dict[phonenumber_monthly_cost_parent.id] = phonenumber_monthly_cost_parent);

    return { ...state, loaded: true, loading: false, phonenumber_monthly_cost_parents: action.payload, dict, };
  case PhonenumberMonthlyCostParentActions.ADD_STATE:
    return { ...state, phonenumber_monthly_cost_parents: [...state.phonenumber_monthly_cost_parents, action.payload, ], dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  case PhonenumberMonthlyCostParentActions.REMOVE_STATE: {

    const { [action.payload]: _deleted, ...dict } = state.dict;

    return { ...state, phonenumber_monthly_cost_parents: state.phonenumber_monthly_cost_parents.filter((item: IPreviewPhonenumberMonthlyCostParent) => item.id !== action.payload), dict, };
  }
  case PhonenumberMonthlyCostParentActions.UPDATE_STATE:
    const phonenumber_monthly_cost_parents = [...state.phonenumber_monthly_cost_parents, ];
    const index = state.phonenumber_monthly_cost_parents.findIndex((phonenumber_monthly_cost_parent: IPreviewPhonenumberMonthlyCostParent) => phonenumber_monthly_cost_parent.id === action.payload.id);

    if (!~index)
      phonenumber_monthly_cost_parents.push(action.payload);
    else
      phonenumber_monthly_cost_parents[index] = action.payload;

    return { ...state, phonenumber_monthly_cost_parents, dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  default:
    return state;
  }
};
